// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"ac506e94","1430":"91a4102a","1615":"ac506e94","3824":"ac506e94"}[chunkId] + ".chunk.css";
};